import s1 from '../assets/1.png';
import s2 from '../assets/2.png';
import s3 from '../assets/3.png';
import s4 from '../assets/4.png';
import s5 from '../assets/5.png';
import s6 from '../assets/6.png';
import s7 from '../assets/7.png';
import s8 from '../assets/8.png';
import s9 from '../assets/9.png';
import s10 from '../assets/10.png';
import s11 from '../assets/11.png';
import s12 from '../assets/12.png';
import s13 from '../assets/13.png';
import s14 from '../assets/14.png';
import s15 from '../assets/13.png';
import s16 from '../assets/16.png';

import auto from '../assets/auto.png';
import manual from '../assets/manual.png';

import start from '../assets/start.png';
import stop from '../assets/stop.png';

import right from '../assets/turn-right.gif';
import left from '../assets/turn-left.gif';

//import marker from '../assets/publicroad/car.png';
import marker from '../assets/8.png';
//import carup from '../assets/publicroad/carup.png';
//import cardown from '../assets/publicroad/cardown.png';
import carup from '../assets/8.png';
import cardown from '../assets/8.png';

import car from '../assets/car.png';
import person from '../assets/person.png';
import obstacleCar from '../assets/obstacle.png';

import pointToB from '../assets/vehicle/PointAtoB.png'
import pointToA from '../assets/vehicle/PointBtoA.png'
import arrivedA from '../assets/vehicle/ArrivedPointA.png'
import arrivedB from '../assets/vehicle/ArrivedPointB.png'
import carStart from '../assets/vehicle/Start.png'
import carStop from '../assets/vehicle/Stop.png'

//地图坐标图片
const mapMarker = marker;
const carUp   = carup;
const carDown = cardown;

const imgs = {
    "sign": [s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16],
    "auto": auto,
    "manual": manual,
    "stop": stop,
    "start": start,
    "right": right,
    "left": left
};

const images = {
  "pointToB": pointToB,
  "pointToA": pointToA,
  "arrivedA": arrivedA,
  "arrivedB": arrivedB,
  "carStart": carStart,
  "carStop": carStop,
}

//障碍物资源
const road = {
    "car": car,
    "person": person,
    "obstacleCar": obstacleCar
};

//websocket url
const WSURL        = "ws://192.168.8.11:8888/websocket";            // Real Car
//old http const BroadcastUrl = "ws://13.112.12.47:8888/websocket";            // Advenlink Japan AWS broadcast server
const BroadcastUrl = "wss://www.mopimanager.com/8888";

//const WSURL        = "ws://13.112.12.47:7777/websocket";            // Advenlink Japan AWS  Vehicle Emulator server
//const WSURL        = "ws://localhost:7777/websocket";       // Advenlink local control server
//const BroadcastUrl = "ws://localhost:8888/websocket";       // Advenlink local broadcast server

//const BroadcastUrl = "ws://39.96.199.238:8888/websocket";            // Advenlink Japan AWS broadcast server
//const WSURL        = "ws://39.96.199.238:7777/websocket";            // Advenlink Japan AWS  Vehicle Emulator server



//const BroadcastUrl = "ws://47.91.30.108:8888/websocket";            // Advenlink Japan broadcast server
//const WSURL        = "ws://47.91.30.108:7777/websocket";            // Advenlink Japan Control server



// const WSURL = "ws://39.96.199.238:7777/websocket";      // Advelink BJ test server
// const WSURL = "ws://54.251.13.222:8888/websocket";      // Huang emulator




export {
    imgs,
    mapMarker,
    carUp,
    carDown,
    road,
    WSURL,
    images,
    BroadcastUrl
}